import { IconProps } from '@models/icons';

function LikeIcon({ size, color, ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path
                d="M16.0923 22.2838C16.0046 22.2843 15.9176 22.2659 15.8364 22.2297C15.7551 22.1934 15.6813 22.14 15.619 22.0725L10.439 17.4823C9.78928 16.765 9.4248 15.7965 9.4248 14.7872C9.4248 13.778 9.78928 12.8095 10.439 12.0921C11.0938 11.3787 11.9809 10.978 12.9057 10.978C13.8304 10.978 14.7175 11.3787 15.3723 12.0921L16.0923 12.8788L16.8123 12.0921C17.4671 11.3787 18.3542 10.978 19.2789 10.978C20.2037 10.978 21.0908 11.3787 21.7456 12.0921C22.3953 12.8095 22.7598 13.778 22.7598 14.7872C22.7598 15.7965 22.3953 16.765 21.7456 17.4823L16.5656 22.0725C16.5033 22.14 16.4295 22.1934 16.3482 22.2297C16.267 22.2659 16.18 22.2843 16.0923 22.2838Z"
                stroke={color} strokeWidth="2"/>
            <circle cx="16" cy="16" r="13.5361" stroke={color} strokeWidth="2"/>
        </svg>
  );
}

export default LikeIcon;
